export default {
  payment: 'payment',
  subscriptionRequest: 'subscriptionRequest'
};



// WEBPACK FOOTER //
// ./src/constants/TransactionTypes.js